<template>
  <page :name="$t('Diventa partner')">
    <template #header>
      {{ $t('Compila questo form indicandoci le tue preferenze per diventare Partner Artera') }}
    </template>

    <pf-page-section>
      <x-form
        @submit="send"
        :prevent-submit="sending"
        :submit-text="$t('Invia')"
        style="max-width: 80ch"
      >
        <form-group
          :name="$t('Modalità')"
          required
          :helper-text="$t(`In modalità 'freelance' saremo noi a fatturare ai tuoi clienti e tu riceverai una provvigione per ogni acquisto fatto dai tuoi clienti. In modalità 'whitelabel' i servizi saranno intestati a te e fatturati a prezzo scontato`)"
          helper-text-before-field
        >
          <pf-form-select :model-value="partner.modalita" @update:model-value="partner.modalita = $as<'whitelabel' | 'freelance' | 'whitelabel-freelance'>($event)" name="modalita" required>
            <pf-form-select-option value="whitelabel">
              {{ $t('Whitelabel') }}
            </pf-form-select-option>
            <pf-form-select-option value="freelance">
              {{ $t('Freelance') }}
            </pf-form-select-option>
            <pf-form-select-option value="whitelabel-freelance">
              {{ $t('Whitelabel e Freelance') }}
            </pf-form-select-option>
          </pf-form-select>
        </form-group>

        <form-group
          :name="$t('Fatturazione mensile')"
          :helper-text="$t('Attivando questa opzione riceverai al massimo una fattura al mese, alla fine del mese, che comprenderà tutti i servizi rinnovati in quel mese.')"
          helper-text-before-field
        >
          <pf-switch v-model:checked="partner.fatturazione_mensile" name="fatturazione_mensile" :label="partner.fatturazione_mensile ? $t('Sì') : $t('No')"/>
        </form-group>

        <form-group
          :name="$t('Sconto provvigioni in fattura')"
          :helper-text="$t('Attivando questa opzione le provvigioni maturate e caricate come \'Credito Artera\' verranno scalate automaticamente in fattura')"
          helper-text-before-field
        >
          <pf-switch v-model:checked="partner.provvigioni_in_fattura" name="provvigioni_in_fattura" :label="partner.provvigioni_in_fattura ? $t('Sì') : $t('No')"/>
        </form-group>
      </x-form>
    </pf-page-section>
  </page>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { Resource } from '@/resources';
import { useFunctionRunningState } from '@common/use';

const router = useRouter();

const partner = ref<{
  modalita: 'whitelabel' | 'freelance' | 'whitelabel-freelance' | null,
  fatturazione_mensile: boolean,
  provvigioni_in_fattura: boolean,
}>({
  modalita: null,
  fatturazione_mensile: true,
  provvigioni_in_fattura: true,
});

const { isRunning: sending, run: send } = useFunctionRunningState(async() => {
  await new Resource('become_partner').post(partner.value);
  router.push('/');
}, { preventMultiple: true });

</script>
